import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { PatientScreeningFormSchema } from "~/services";

export const useFocusEmailOnError = () => {
  const {
    setFocus,
    formState: { errors },
  } = useFormContext<PatientScreeningFormSchema>();
  const [isFocusPending, setIsFocusPending] = useState(false);

  useEffect(() => {
    if (!isFocusPending) return;

    setIsFocusPending(false);
    if (errors.email) setFocus("email");
  }, [isFocusPending, errors.email, setFocus]);

  return () => setIsFocusPending(true);
};
